const headerMenu = document.querySelector("#masthead");
const headerMenuRect = headerMenu.getBoundingClientRect();
const headerMenuTop = headerMenuRect.height;

const campaignPage = document.querySelector("body.page-template-campaign");
const accordionHeaders = document.querySelectorAll('button.accordion-header');
const accordionMobileToggle = document.querySelectorAll('button.accordion-mobile-toggle');
const allAccordionPanels = document.querySelectorAll(".accordion-panel");
const allCtaBtns = document.querySelectorAll("button.accordion-header .button-cta-main");

function toggleAccordion(e) {
    const header = e.currentTarget;
    const cta = header.querySelector('.button-cta-main');
    const ctaOpen = cta.querySelector('span.open');
    const ctaClose = cta.querySelector('span.close');
    const wrapper = header.closest(".js-accordion");
    let panel = wrapper.querySelector('.accordion-panel');
    let ariaExpanded = header.getAttribute('aria-expanded');

    if( ariaExpanded === 'false' ) {
        allAccordionPanels.forEach(accPanel => {
            accPanel.style.maxHeight = 0;
        })
        allCtaBtns.forEach(ctaBtn => {
            ctaBtn.classList.remove("active");
            ctaBtnOpen = ctaBtn.querySelector("span.open");
            ctaBtnClose = ctaBtn.querySelector("span.close");
            if( ctaBtnOpen) {
                ctaBtnOpen.hidden = false;
            }
            if( ctaBtnClose) {
                ctaBtnClose.hidden = true;
            }
        })
        accordionHeaders.forEach(accHeader => {
            accHeader.setAttribute('aria-expanded', false);
        })

        header.setAttribute('aria-expanded', true);
        cta.classList.add("active");
        if( ctaOpen) {
            ctaOpen.hidden = true;
        }
        if( ctaClose) {
            ctaClose.hidden = false;
        }
        panel.style.maxHeight = "100%";
        setTimeout(function () {
            const rect = wrapper.getBoundingClientRect();
            const headerTop = rect.y + window.pageYOffset - headerMenuTop;
            window.scrollTo(0, headerTop);
        }, 400);

    } else {
        allAccordionPanels.forEach(accPanel => {
            accPanel.style.maxHeight = 0;
        })
        allCtaBtns.forEach(ctaBtn => {
            ctaBtn.classList.remove("active");
            ctaBtnOpen = ctaBtn.querySelector("span.open");
            ctaBtnClose = ctaBtn.querySelector("span.close");
            if( ctaBtnOpen) {
                ctaBtnOpen.hidden = false;
            }
            if( ctaBtnClose) {
                ctaBtnClose.hidden = true;
            }
        })
        accordionHeaders.forEach(accHeader => {
            accHeader.setAttribute('aria-expanded', false);
        })
    }
}

// function toggleSingleAccordion(e) {
//     const header = e.currentTarget;
//     const cta = header.querySelector('.button-cta-main');
//     const ctaOpen = cta.querySelector('span.open');
//     const ctaClose = cta.querySelector('span.close');
//     let panel = header.nextElementSibling;
//     let ariaExpanded = header.getAttribute('aria-expanded');

//     if( ariaExpanded === 'false' ) {
//         header.setAttribute('aria-expanded', true);
//         cta.classList.add("active");
//         ctaOpen.hidden = true;
//         ctaClose.hidden = false;
//         panel.style.maxHeight = "100%";

//     } else {
//         header.setAttribute('aria-expanded', false);
//         cta.classList.remove("active");
//         ctaOpen.hidden = false;
//         ctaClose.hidden = true;
//         panel.style.maxHeight = "0";
//     }
// }

function closeMobileAccordion(e) {
    const button = e.currentTarget;
    const accordion = button.parentElement.parentElement.parentElement;
    const header = accordion.querySelector(".accordion-header");
    const cta = header.querySelector('.button-cta-main');
    const ctaOpen = cta.querySelector('span.open');
    const ctaClose = cta.querySelector('span.close');
    let panel = header.nextElementSibling;
    header.setAttribute('aria-expanded', "false");
    panel.classList.remove("active");
    cta.classList.remove("active");
    if(ctaOpen) {
        ctaOpen.hidden = false;
    }
    if(ctaClose) {
        ctaClose.hidden = true;
    }
}

accordionHeaders.forEach(header => {
    header.addEventListener("click", function(e) {
        toggleAccordion(e);
    }); 
})

accordionMobileToggle.forEach(button => {
    button.addEventListener("click", function(e) {
        closeMobileAccordion(e);
    })
})